export default "__VITE_ASSET__91874986__"